module.exports = __webpack_public_path__ + "img/fan.2f3a6bd0.svg";